import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { 
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, FormGroup, Input, Row, Col, Label,
  UncontrolledTooltip
} from 'reactstrap'
import { Accordion, Card } from 'react-bootstrap'
import Frame from 'react-frame-component'
import { IoMdRefresh } from 'react-icons/io'
import { StyleRoot } from 'proofpoint-radium'

import Lang from 'Lang/General'
import ColorPickerInput from 'components/ColorPicker'
import MultilingualInput from 'components/MultiLangInput/v2'
import { getBorderStyling, getButtonColorType, getModifiedColorTypeStyling } from 'components/ButtonSettings/utils'
import StyleSheetHOC from './actions/stylesheets'
import { patchIdsChildren } from 'utils/uniqueIds'
import { ApplyColorCss } from 'utils/apply-color'
// import CoreRenderFunction from 'DisplayCore'
import LinkInput from './Utility/linkInput'

const newButton = {
  id: "",
  type: "button",
  style: {
    color: "#ffffff",
    background: "#238acc",
    border: "none",
    borderRadius: ".25rem",
    outline: "none",
    padding: "5px 8px",
    transition: "0.3s linear all",
    ':hover': {
      color: "#000000",
      background: "#ffffff",
      border: "1px solid #000000"
    }
  },
  children: [{
    id: "",
    type: "div",
    variant: "text",
    style: { zIndex: 2, position: "relative" },
    content: Lang[ 'SUBMIT' ]
  }]
}

const ButtonConfigModal = props => {
  let {
    showSelectButtonModal,
    site,
    siteSettings,
    selectedLanguage,
    components,
    selectedTempComponent,
    onChangeTempComponent,
    getStylesheets,
    stylesheets,
    anchorLinks,
    pages,
    toggleMediaDatabase,
    redirectInfo,
    onChangeRedirectInfo
  } = props

  const [ bottomButtonText, updateBottomButtonText ] = useState( Lang[ 'SUBMIT' ] )
  const [ selectedButtonTemplate, updateSelectedButtonTemplate ] = useState( _.cloneDeep( newButton ) )

  useEffect(() => {
    if( showSelectButtonModal ){
      if( _.isEmpty( selectedTempComponent ) ){
        let tmp = _.cloneDeep( newButton )
        patchIdsChildren( tmp )
        onChangeTempComponent( 'selectedTempComponent', tmp )
      } else {
        let tmp = _.find( components, component => component.content.className === selectedTempComponent.className )
        updateSelectedButtonTemplate( tmp ? tmp.content : newButton )
        if( !_.isEmpty( selectedTempComponent.content )){
          updateBottomButtonText( selectedTempComponent.content )
        } else if( selectedTempComponent.children?.length > 0 ) {
          updateBottomButtonText( selectedTempComponent.children[0].content )
        }
      }
      // getStylesheets( site.id )
    }
  }, [ showSelectButtonModal ])

  const onChangeButtonStyle = ( key, val, isHover ) => {
    let tmp = _.cloneDeep( selectedTempComponent )
    if( isHover ){
      if( !tmp.style[ ':hover' ] ){
        tmp.style[ ':hover' ] = {}
      }
      if( key === "border" ){
        let tmpBorder = getBorderStyling( tmp.style[ ':hover' ] )
        if( Object.keys( tmpBorder ).length > 0 ){
          _.map( ( tmpBorder ), ( value, key ) => {
            tmp.style[ ':hover' ][ key ] = value.replace( /#[^ ]*\b/g, val )
          })
        }
      } else {
        if( key === "outline" && !tmp.style[ ':hover' ][ key ]?.indexOf( 'px' ) > -1 ){
          tmp.style[ ':hover' ][ key ] = `1px solid ${ val }`
        } else {
          tmp.style[ ':hover' ][ key ] = val
        }
      }
    } else {
      if( key === "border" ){
        let tmpBorder = getBorderStyling( tmp.style )
        if( Object.keys( tmpBorder ).length > 0 ){
          _.map( ( tmpBorder ), ( value, key ) => {
            tmp.style[ key ] = value.replace( /#[^ ]*\b/g, val )
          })
        }
      } else {
        if( key === "outline" && !tmp.style[ key ]?.indexOf( 'px' ) > -1 ){
          tmp.style[ key ] = `1px solid ${ val }`
        } else {
          tmp.style[ key ] = val
        }
      }
    }
    onChangeTempComponent( "selectedTempComponent", tmp )
  }

  const onChangeButtonColorType = ( type, key, isHover ) => {
    let tmp = _.cloneDeep( selectedTempComponent )
    let tmpStyle = {}

    if( isHover ){
      if( !tmp.style[ ':hover' ] ){
        tmp.style[ ':hover' ] = {}
      }
    }
    tmpStyle = _.cloneDeep( isHover ? tmp.style[ ':hover' ] : tmp.style )

    if( !tmpStyle[ key ] && key !== 'border' ){
      tmpStyle[ key ] = "#000000"
    }
    if( key === "border" ){
      _.map( getBorderStyling( isHover ? tmp.style[ ':hover' ] : tmp.style ), ( value, borderKey ) => {
        tmpStyle = getModifiedColorTypeStyling( type, tmpStyle, borderKey )
      })
    } else {
      if( !tmpStyle[ key ] ){
        if( key === "outline" ){
          tmpStyle[ key ] = '1px solid #000000'
        } else {
          tmpStyle[ key ] = "#000000"
        }
      }
      tmpStyle = getModifiedColorTypeStyling( type, tmpStyle, key )
    }

    if( isHover ){
      tmp.style[ ':hover' ] = tmpStyle
    } else {
      tmp.style = tmpStyle
    }
    onChangeTempComponent( "selectedTempComponent", tmp )
  }

  const ColorPicker = ( attr, isHover ) => {
    let tmpStyle = isHover 
      ? selectedTempComponent.style[ ':hover' ]
        ? selectedTempComponent.style[ ':hover' ]
        : {}
      : selectedTempComponent.style
    let isReplace = attr !== "border" ? tmpStyle[ attr ]?.indexOf( '#' ) > -1 : false
    let attrColor = attr === "border" 
      ? Object.values( getBorderStyling( tmpStyle ) )[ 0 ]?.match( /#[^ ]*\b/g )[ 0 ] || ''
      : isReplace 
        ? tmpStyle[ attr ].match( /#[^ ]*\b/g )[0]
        : ""
    return(
      <ColorPickerInput
        id={ `button_${ attr }` }
        size={ 6 }
        label={ Lang[ attr === "backgroundColor" ? "BACKGROUND" : attr.toUpperCase() ][ selectedLanguage ] }
        color={ attrColor }
        colorType={ getButtonColorType( 
          tmpStyle, 
          attr === "border" 
            ? Object.keys( getBorderStyling( tmpStyle ) )[ 0 ] 
            : attr 
        )}
        siteSettings={ siteSettings }
        selectedLanguage={ selectedLanguage }
        onChange={ col => {
          onChangeButtonStyle(
            attr, 
            isReplace ? tmpStyle[ attr ].replace( /#[^ ]*\b/g, col.hex ) : col.hex, 
            isHover
          )
        }}
        onChangeColorType={ type => onChangeButtonColorType( type, attr, isHover ) }
        enableAttrRemoval
      />
    )
  }

  return (
    <Modal isOpen={ showSelectButtonModal } size={ 'lg' }>
      <ModalHeader toggle={() => onChangeTempComponent( 'showSelectButtonModal', false )}>
        { Lang[ 'BUTTON_CONFIGURATION' ][ selectedLanguage ] }
      </ModalHeader>
      { 
        !_.isEmpty( selectedTempComponent ) && (
          <ModalBody>
            <Frame
              id={ 'editor-section-renderer' }
              style={{
                width: '100%',
                height: '75px',
                marginBottom: '20px'
              }}
              initialContent={ '<!DOCTYPE html><html><head><link href="/static/site.css" rel="stylesheet"></link><link href="/static/image-block-styles.css" rel="stylesheet"></link><link href="/static/ckeditor/content-styles.css" rel="stylesheet"></link><link href="/static/bootstrap.css" rel="stylesheet"></link></head><body style="overflow-y:scroll;overflow-x:hidden;"><div></div></body></html>' }>
              <StyleRoot>
                <div
                  style={{
                    width: '100%',
                    height: '100vh',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  {
                    stylesheets && stylesheets.length > 0 && stylesheets.map( item => {
                      if( item.type === 'URL' ) {
                        return <link key={ `stylesheet-${ item.id }` } rel="stylesheet" href={ item.content }></link>
                      } else {
                        return <style key={ `stylesheet-${ item.id }` }>{ siteSettings && ( item.content.indexOf( 'primaryColor' ) > -1 || item.content.indexOf( 'secondaryColor' ) > -1 )
                          ? ApplyColorCss( item.content, siteSettings.primary_color, siteSettings.secondary_color )
                          : item.content }
                        </style>
                      }
                    })
                  }
                   <style>
                  {`:root {
                      --site-primary-color: ${siteSettings.primary_color};
                      --site-secondary-color: ${siteSettings.secondary_color};
                    }`}
                  </style>
                  <style>{ `body { font-family: '${ siteSettings[ 'font_family' ] }'; background-color: #ffffff !important; }` }</style>
                  <style>{ `.vital-carousel-button-hover-animation:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; } \n.vital-carousel-button-hover-animation:hover:after { width: 100%; }\n.vital-carousel-button-hover-animation:hover .vital-carousel-button-text { color: #000000 !important; }\n\n.vital-carousel-bg-effect:after { position: absolute; display: block; width: 100%; height: 100%; background: linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.9) 63%, #000 100%); top: 0; left: 0; opacity: 0.35; content: ''; z-index: 1; }\n\n.launch-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #72376b; transition: 0.4s; }\n.launch-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.launch-image-hover-animation:after { content: ''; position: absolute; top: -110%; left: -210%; width: 200%; height: 200%; opacity: 0; transform: rotate(30deg); background: linear-gradient(to right, rgba(245,242,241,0.43) 0%, rgba(245,242,241,0.13) 77%, rgba(245,242,241,0.5) 92%, rgba(245,242,241,0) 100%); z-index:2; transition: all 0.3s, opacity 0s; }\n.launch-image-hover-animation:hover:after { opacity: 1; top: -90%; left: -80%;  }\n\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-image { transform: scale(1.25); }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox { justify-content: center; bottom: 16px !important; }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox-text { opacity: 1 !important; }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox-button { opacity: 1 !important; }\n\n.fashion-carousel-slanted-bg:before { content: ''; width: 100%; height: 100%; background-color: rgba(255,255,255,0.8); display: block; z-index: -1; position: absolute; top: 0; left: 0; transform: rotate(-5deg); }\n\n.fashion-carousel-button-animation-lr:before { content: ''; background-color: #842e2e; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.fashion-carousel-button-animation-lr:hover:before { width: 100%; }\n\n.fashion-carousel-bg-effect{ filter: contrast(0.5) brightness(1.3) opacity(1); }\n\n.fashion-carousel-bg-effect:after { position:absolute; display: block; width: 100%; height: 100%; top: 0; left: 0; content: ''; z-index: 1; opacity: 0.6; background-image: url(https://fashion-de.oms-suite.de/assets/themes/fashion_de/assets/images/template/muster4.png); }\n\n.fashion-grid:hover .fashion-grid-image { transform: scale(1.2) !important; } \n.fashion-grid:hover .fashion-grid-description { max-height: 100% !important; }\n\n.fashion-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #842e2e; transition: 0.4s; } \n.fashion-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.injoy-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #004063; transition: 0.4s; }\n.injoy-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.injoy-image-hover-animation:after { content: ''; position: absolute; top: -110%; left: -210%; width: 200%; height: 200%; opacity: 0; transform: rotate(30deg); background: linear-gradient(to right, rgba(245,242,241,0.43) 0%, rgba(245,242,241,0.13) 77%, rgba(245,242,241,0.5) 92%, rgba(245,242,241,0) 100%); z-index:2; transition: all 0.3s, opacity 0s; }\n.injoy-image-hover-animation:hover:after { opacity: 1; top: -90%; left: -80%;  }\n.injoy-image-hover-animation:hover div { transform: scale(1.10); }\n\n.injoy-carousel-button-animation-lr:before { content: ''; background-color: #808080; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.injoy-carousel-button-animation-lr:hover:before { width: 100%; }\n\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-image { transform: scale(1.25); }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox { justify-content: center; bottom: 16px !important; }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox-text { opacity: 1 !important; }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox-button { opacity: 1 !important; }\n\n.plus-icon:before { content: ''; position: absolute; background: #252525; top: 0; left: 50%; width: 1px; height: 100%; margin-left: -1px; }\n.plus-icon:after { content: ''; position: absolute; background: #252525; top: 50%; left: 0; width: 100%; height: 1px; margin-left: -1px; }\n\n.minus-icon:before { content: ''; position: absolute; background: #252525; top: 50%; left: 0; width: 100%; height: 1px; margin-left: -1px; }\n\n.left-right-reverse-primary-animated-button-v2:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; }\n\n.left-right-reverse-primary-animated-button-v2:hover:after { width: 100%; }` }</style>
                  {/* <CoreRenderFunction
                    site={ site } 
                    siteSettings={ siteSettings }
                    item={ selectedTempComponent }
                    selectedLanguage={ selectedLanguage }
                    mode={ 'section-display-edit' }/> */}
                </div>
              </StyleRoot>
            </Frame>
            <FormGroup>
              <Label>{ Lang[ 'BUTTON_TYPE' ][ selectedLanguage ] }</Label>
              <Input
                type="select"
                value={ selectedTempComponent.className }
                onChange={ e => {
                  if( e.target.value !== "" ){
                    let tmp = _.cloneDeep( _.find( components, component => component.content.className === e.target.value ).content )
                    updateSelectedButtonTemplate( _.cloneDeep( tmp ) )
                    tmp.children[0].content = bottomButtonText
                    patchIdsChildren( tmp )
                    onChangeTempComponent( 'selectedTempComponent', tmp )
                  } else {
                    let tmp = _.cloneDeep( newButton )
                    updateSelectedButtonTemplate( newButton )
                    patchIdsChildren( tmp )
                    onChangeTempComponent( 'selectedTempComponent', tmp )
                  }
                }}>
                <option value="">{ Lang[ 'DEFAULT' ][ selectedLanguage ] }</option>  
                {
                  components.map( component => {
                    return <option value={ component.content.className }>{ component.name }</option>
                  })
                }
              </Input>
            </FormGroup>
            <Row>
              <Col lg={ 5 } style={{ marginBottom: "10px" }}>
                <MultilingualInput
                  label={ Lang[ 'TEXT' ][ selectedLanguage ] }
                  selectedLanguage={ selectedLanguage }
                  value={ bottomButtonText }
                  parent={ bottomButtonText }
                  parentName={ "bottomButtonText" }
                  onChangeValue={ ( key, val ) => {
                    let tmp = _.cloneDeep( selectedTempComponent )
                    if( !_.isEmpty( tmp.content )){
                      tmp.content = val
                    } else if( tmp.children?.length > 0 ) {
                      tmp.children[0].content = val
                    }
                    updateBottomButtonText( val )
                    onChangeTempComponent( 'selectedTempComponent', tmp ) 
                  }} />
              </Col>
              <Col lg={ 7 }>
                <LinkInput 
                  selectedContainer={ redirectInfo }
                  onUpdate={ ( updatedDom ) => onChangeRedirectInfo( updatedDom ) }
                  setMediaDatabase={ ( isOpen ) => {
                    toggleMediaDatabase( isOpen )
                  }}
                  anchorLinks={ anchorLinks }
                  pages={ pages }
                  site={ site }
                  selectedLanguage={ selectedLanguage }
                />
              </Col>
            </Row>
            <FormGroup>
              <div className="d-flex align-items-center mb-1">
                <Label className="m-0">{ Lang[ 'STYLE' ][ selectedLanguage ] }</Label>
                {
                  !_.isEqual( selectedButtonTemplate.style, selectedTempComponent.style ) && (
                    <>
                      <IoMdRefresh 
                        id='reset_button_style'
                        style={{ cursor: 'pointer', marginLeft: '5px', fontSize: '18px'  }}
                        onClick={()=>{
                          let tmp = _.cloneDeep( selectedTempComponent )
                          tmp.style = selectedButtonTemplate.style
                          onChangeTempComponent( 'selectedTempComponent', tmp )
                        }}/>
                        <UncontrolledTooltip
                          target='reset_button_style'
                          placement="top">
                          { Lang[ 'RESET' ][ selectedLanguage ] }
                        </UncontrolledTooltip>
                      </>
                  )
                }
              </div>
              <Accordion>
                <Card style={{ overflow: "visible" }}>
                  <Accordion.Toggle
                    eventKey="button_color"
                    as={Card.Header}>
                    { Lang[ 'BUTTON_COLOR' ][ selectedLanguage ] }
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="button_color">
                    <Card.Body>
                      <Row>
                        { ColorPicker( 'color' ) }
                        { ColorPicker( selectedTempComponent.style.background?.indexOf( '#' ) > -1 ? 'background' : 'backgroundColor' ) }
                      </Row>
                      <Row>
                        { ColorPicker( 'outline' ) }
                        { Object.keys( getBorderStyling( selectedTempComponent.style )).length > 0 && ColorPicker( 'border' ) }
                      </Row>  
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card style={{ overflow: "visible" }}>
                  <Accordion.Toggle
                    eventKey="button_hover_color"
                    as={Card.Header}>
                    { Lang[ 'BUTTON_HOVER_COLOR' ][ selectedLanguage ] }
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="button_hover_color">
                    <Card.Body>
                      <Row>
                        { ColorPicker( 'color', true ) }
                        { ColorPicker( selectedTempComponent.style.background?.indexOf( '#' ) > -1 ? 'background' : 'backgroundColor', true ) }
                      </Row>
                      <Row>
                        { ColorPicker( 'outline', true ) }
                        { Object.keys( getBorderStyling( selectedTempComponent.style[ ':hover' ] )).length > 0 && ColorPicker( 'border', true ) }
                      </Row>  
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </FormGroup>
          </ModalBody>
        )
      }
      <ModalFooter>
        <Button
          onClick={ () => onChangeTempComponent( 'showSelectButtonModal', false ) }>
          { Lang[ 'CLOSE' ][ selectedLanguage ] }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default StyleSheetHOC( ButtonConfigModal )